package org.lennycodes.hldi.pages.admin
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.doc
import org.lennycodes.hldi.backend.setDoc
import org.lennycodes.hldi.data.BlogPost
import org.lennycodes.hldi.data.GalleryImage


@Composable
fun AddBlogDialog(
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()

    var imagesList by remember { mutableStateOf<List<GalleryImage>>(emptyList()) }

    var title by remember { mutableStateOf("") }
    var content by remember { mutableStateOf("") }
    var author by remember { mutableStateOf("Admin") }
    var category by remember { mutableStateOf("") }
    var date by remember { mutableStateOf("") }
    var imageUrl by remember { mutableStateOf("") }

    var loading by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf("") }


    LaunchedEffect(Unit) {
        imagesList = AdminRepository.getGalleryImages()
    }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!loading) {
                        onDismiss()
                    }
                }

            }
    ) {

        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {

            H3 {
                Text("Create Blog Post")
            }


            BlogField(
                "Title",
                title,
                { title = it }
            )

            BlogField(
                "Content",
                content,
                { content = it },
                true
            )


            // Category

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Category")
                }

                Select(
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            onChange {
                                category = it.value.toString()
                            }

                            if (loading) {
                                disabled()
                            }

                        }
                ) {

                    Option(
                        value = "",
                        attrs = {
                            disabled()
                            if (category.isEmpty()) {
                                selected()
                            }
                        }
                    ) {
                        Text("Select category")
                    }

                    Option(
                        value = "Education",
                        attrs = {
                            if (category == "Education") selected()
                        }
                    ) {
                        Text("Education")
                    }

                    Option(
                        value = "Legal Aid",
                        attrs = {
                            if (category == "Legal Aid") selected()
                        }
                    ) {
                        Text("Legal Aid")
                    }

                    Option(
                        value = "Health",
                        attrs = {
                            if (category == "Health") selected()
                        }
                    ) {
                        Text("Health")
                    }

                    Option(
                        value = "Community Development",
                        attrs = {
                            if (category == "Community Development") selected()
                        }
                    ) {
                        Text("Community Development")
                    }

                }

            }


            // Date

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Date")
                }

                Input(
                    type = InputType.Date,
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            placeholder("2026-08-20")

                            value(date)

                            onInput {
                                date = it.value
                            }

                            if (loading) {
                                disabled()
                            }

                        }
                )

            }


            // Featured image (pulled from the gallery collection)

            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {
                    Text("Featured Image")
                }

                Select(
                    attrs = Modifier
                        .padding(11.px, 14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            onChange {
                                imageUrl = it.value.toString()
                            }

                            if (loading) {
                                disabled()
                            }

                        }
                ) {

                    Option(
                        value = "",
                        attrs = {
                            disabled()
                            if (imageUrl.isEmpty()) {
                                selected()
                            }
                        }
                    ) {
                        Text("Select image")
                    }

                    imagesList.forEach { image ->

                        Option(
                            value = image.url,
                            attrs = {
                                if (imageUrl == image.url) {
                                    selected()
                                }
                            }
                        ) {
                            Text(image.title)
                        }

                    }

                }

            }


            if (error.isNotEmpty()) {

                P(
                    attrs = Modifier
                        .color(Color.rgb(220, 53, 69))
                        .toAttrs()
                ) {
                    Text(error)
                }

            }


            Row(
                modifier = Modifier
                    .margin(8.px)
                    .fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {

                Button(
                    modifier = Modifier
                        .padding(11.px, 22.px)
                        .then(CancelButtonStyle.toModifier()),
                    enabled = !loading,
                    onClick = {
                        onDismiss()
                    }
                ) {
                    Text("Cancel")
                }


                Button(
                    enabled = !loading,
                    modifier = Modifier
                        .padding(11.px, 22.px)
                        .then(SaveButtonStyle.toModifier()),
                    onClick = {

                        scope.launch {

                            try {

                                error = ""

                                if (title.isBlank()) {
                                    error = "Title is required"
                                    return@launch
                                }

                                loading = true


                                val id = generateFirebaseId()

                                val blog = BlogPost(
                                    id = id,
                                    title = title,
                                    content = content,
                                    author = author,
                                    date = date,
                                    category = category,
                                    imageUrl = imageUrl
                                )


                                val blogs = collection(
                                    FirebaseService.db,
                                    "blogs"
                                )

                                val blogDoc = doc(
                                    blogs,
                                    id
                                )


                                setDoc(
                                    blogDoc,
                                    blog.toFirebaseData()
                                ).await()


                                console.log("Blog saved")


                                onSuccess()

                                onDismiss()


                            } catch (e: Throwable) {

                                error = e.message ?: "Failed saving blog"

                            } finally {

                                loading = false

                            }

                        }

                    }
                ) {

                    Text(
                        if (loading) "Saving..." else "Save"
                    )

                }

            }

        }

    }

}


// ---------------- FIELD COMPONENT ----------------


@Composable
fun BlogField(
    label:String,
    value:String,
    onChange:(String)->Unit,
    multiline:Boolean=false
){

    Div {


        Label {

            Text(label)

        }



        if(multiline){


            TextArea(
               value = value,
                attrs =
                    Modifier
                        .padding(12.px)
                        .then(
                            FieldInputStyle.toModifier()
                        )
                        .toAttrs {

                            placeholder(label)

                            onInput {

                                onChange(
                                    it.value
                                )

                            }

                        }

            )


        }
        else{


            Input(

                type = InputType.Text,

                attrs =
                    Modifier
                        .padding(12.px)
                        .then(
                         FieldInputStyle.toModifier()
                        )
                        .toAttrs {

                            placeholder(label)

                            value(value)

                            onInput {

                                onChange(
                                    it.value
                                )

                            }

                        }

            )


        }


    }

}